import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46bc6f98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "error-container" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = {
  key: 0,
  class: "buttons"
}

import { ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/vue/24/outline';
import Button from '@/components/ui/Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoDisplay',
  props: {
    description: {},
    type: {},
    primaryButtonProps: {},
    secondaryButtonProps: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.type === 'error')
        ? (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
            key: 0,
            class: "icon-error"
          }))
        : (_openBlock(), _createBlock(_unref(InformationCircleIcon), {
            key: 1,
            class: "icon-info"
          })),
      _createElementVNode("div", _hoisted_3, _toDisplayString(props.description), 1)
    ]),
    (_ctx.primaryButtonProps || _ctx.secondaryButtonProps)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.primaryButtonProps)
            ? (_openBlock(), _createBlock(Button, {
                key: 0,
                variant: "primary",
                onClick: _ctx.primaryButtonProps.onClick,
                loading: _ctx.primaryButtonProps.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true),
          (_ctx.secondaryButtonProps)
            ? (_openBlock(), _createBlock(Button, {
                key: 1,
                variant: "primary",
                onClick: _ctx.secondaryButtonProps.onClick,
                loading: _ctx.secondaryButtonProps.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})